/* eslint-disable quotes */
// Chinês
export const chines = {
  start: "开始",
  save: "保存",
  delete: "删除",
  update: "更新",
  lets: "开始游戏",
  permanentbuy: "永久购买",
  signature: "月度订阅",
  weekly: "周费订阅",
  signatureano: "年度订阅",
  male: "男性",
  female: "女性",
  ambos: "两者",
  time: "时间",
  choosecategory: "选择类别",
  categories: "类别",
  light: "轻松",
  preliminary: "前戏",
  oral: "口交",
  anal: "肛交",
  hot: "热辣",
  extreme: "极端",
  vd: "真相",
  dare: "大冒险",
  truth: "真相",
  createMyChallenges: "创造我的挑战",
  chosen: "已选",
  text3: "让爱在你心中流淌！",
  text4: "准备好去过上激情的生活",
  close: "关闭",
  dev: "由 Dev12BR 开发",
  next: "下一步",
  config3: "无广告",
  config4: "选择升级的头像",
  config9: "创建和编辑您自己的挑战",
  version: "高级版",
  alert3: "请选择至少一个类别",
  tituloAlert1: "⚠️游戏即将开始😜",
  duvidas: "疑问或建议 - 热辣挑战",
  description: "你好，我的问题或建议是：",
  send: "发送",
  contact: "联系",
  botaoApple: "恢复购买",
  alertCompra: "您的购买正在恢复",
  NotPurchase: "您没有任何购买。",
  options: "选项",
  avalie: "评分",
  novaCategoria: "我的分类",
  alterLanguage: "更改语言？",
  textLanguage: "选择新语言后，应用将重新启动。",
  textLanguage1: "切换语言",
  cancel: "取消",
  languages: "语言",
  deletCat: "删除分类",
  textDeletCat: "删除该类别后，该类别中的挑战也将被删除。删除后将无法再撤销。",
  deletDes: "删除挑战",
  textDeletDes: "删除挑战后，此操作将无法再撤销。 ",
  desafio: "注册新挑战",
  desafiotexto: "挑战",
  textoeditDesafio: "谁能做到这一点？",
  textEmquem: "对谁？",
  nome: "名字",
  inicio: "开始游戏",
  inicio9: "帮助",
  cadastrarCategory: "创建新类别",
  inicio15: "创建新分类",
  inicio16:
    "步骤 1：按下屏幕底部的 + 号按钮。按下后，会出现一个窗口，您可以在其中输入新类别。 ",
  inicio17: "步骤 2：输入新类别并点击保存",
  inicio18: "步骤 3：要编辑该类别或在类别中添加挑战，请点击该类别。 ",
  inicio19:
    "步骤 4：在下一屏幕中，按下箭头所示的按钮 ⬆️。这将打开一个窗口，用于编辑新类别。 ",
  inicio20: "骤5：在下一个屏幕上，按下用箭头⬆️指示的按钮，您将删除该类别。 ",
  inicio21: "第 1 步： 按下面的按钮为该类别添加新挑战",
  inicio22: "创建新挑战",
  inicio23: "步骤2：点击每个圈圈标志，了解每个注册字段的详细信息",
  inicio24: "挑战文本",
  inicio25: `以您喜欢的方式编写挑战，为了在挑战中显示玩家的姓名，只需按下下面的红色按钮。
    
它将添加以下字符 {nome}。

** 请不要更改这些字符 ** 为了正确显示姓名，它需要按照下面的描述 ⬇️⬇️⬇️⬇️

挑战：亲吻{name}的脖子`,
  inicio26: "谁能做，谁能接受",
  inicio27: `如果挑战可以由“两者”性别的参与者执行和接收，请选择“两者”。
  
如果挑战是针对一个性别的，请选择所需的性别
`,
  inicio28: "为挑战添加时间",
  inicio29:
    "如果您的挑战有时间限制，请只需拖动下方的“范围”，该值将显示在上方。在挑战中计时器到期后，将播放声音通知挑战结束。",
  aviso12: `在这里，您只需创建类别！
 
  要添加挑战，只需点击您刚刚创建的类别的按钮 ⬆️⬆️⬆️⬆️ 
  `,
  voltar: "返回",
  semDe: "没有挑战的玩家",
  semDe2: `为这个玩家注册至少一个挑战 😬。
  
您将被重定向到登录屏幕。`,
  term: "隐私",
  Potitic: "使用条款",
  adquirited: "已购买",
  config10: "独家类别",
  config11: "800+个新挑战",
  camera: "相机",
  galery: "相册",
  avatar: "头像",
  image: "图片",
  seletion: " 已选择",
  editCategory: "编辑类别",
  frase1: "您喜欢这些挑战吗？",
  frase2: "尝试一下高级挑战怎么样呢？",
  errTexto: "如果发现翻译错误，请在下框中更正： ",

  errTitulo: "注意到什么问题了吗？",
  errCorrect: "用中文会怎么说？",
  thisLanguageIsCorrect: "这个挑战用中文是否正确？",
  yes: "是",
  no: "否",

  errSend: "发送建议",

  share: "分享",
  fraseShare: `这个app很棒！只是分享一下，因为我知道你也会喜欢！
下载后再告诉我它是不是太棒啦...😉 
  
  
下载链接 : https://desafiospicantesapp.page.link/share-app`,
  bandeira: "🇨🇳",

  morePlayer: "和更多的玩家一起玩？",
  players: "玩家",
  carregar: "上传图片",
  takePhoto: "拍照或选择一张图片",
  useAvatar: "或使用头像",

  hetero: "异性恋",
  gay: "同性恋",
  lesbico: "女同性恋",

  nomeHomem1: "男性姓名",
  nomeHomem2: "男性姓名",
  nomeMulher1: "女性姓名",
  nomeMulher2: "女性姓名",
  messageErr: "添加玩家 🙌",
  descricaoErr: "输入参与者的姓名 ✍️",
  why: "告诉我们为什么...",
  later: "稍后评估",
  txtCard1: "轮到你了🔥",
  txtCard2: "让它发生 😘",
  txtCard3: "走吧! 😜",
  txtCard4: "下一个挑战 😈",
  txtCard5: "再来一个! 👄",

  tituloBloco1Novo: "与伴侣探索性亲密关系",
  subtitulo1Novo: "超过1百万幸福夫妇",
  texto1Novo:
    "解锁亲密关系，进入最适合情侣的游戏！现在就解锁所有游戏，不同类别的游戏专为您打造，让您从亲密关系中获得最佳体验! ",

  tituloBloco2Novo: "新的经验，更好的关系",
  texto2Novo1: "享受1500多个挑战",
  texto2Novo2: "无广告",
  texto2Novo3: "独家头像",
  texto2Novo4: "每天更新新挑战",
  texto2Novo5: "定期推出新游戏",
  texto2Novo6: "创造自己的挑战",
  texto2Novo7: "定期更新的游戏",
  tituloBloco3Novo: "类别最高分",
  tituloBloco4Novo: "对您的关系的好处：",
  texto4Novo1: "亲密",
  texto4Novo2: "欲望",
  texto4Novo3: "轻松",
  texto4Novo4: "吸引力",
  texto4Novo5: "连接",
  texto4Novo6: "愉悦",

  tituloBloco5Novo: "看看其他情侣的意见",
  texto5depoimentoTitulo1: "Blade Moody",
  texto5depoimento1: `这个app太棒了！我是否应该下载还是不下载还犹豫不决，但这绝对是我们近期的最佳感觉。知道我们仍然可以一起做很多事情是多么美好。🤭 我们测试了付费版本，真的很值得，我们之前还没有达到这种愉悦的程度。`,
  texto5depoimentoTitulo2: "Joon Rxs",
  texto5depoimento2:
    "如果你想为你们的关系增添情趣，这款app就再合适不过了！我试过其他app，但都不如这款软件让我们满意。我们的前戏变得更加火热、更加愉悦（现在想象一下其他方面吧！）它真的值得购买付费版（如果你想感受更强烈的快感的话），但免费版也很让人惊喜。",
  texto5depoimentoTitulo3: "Monique SantosRader",
  texto5depoimento3:
    "如果你想激发关系，这个应用程序是完美的！我已经测试过其他一些，但没有一个能像这个一样让我们满意。我们的前戏更加火辣而愉悦（现在想象其余的！）购买付费版本真的很值得（如果你想感受更强烈的愉悦），但免费版本也令人惊讶。",
  texto5depoimentoTitulo4: "Anne owens",
  texto5depoimento4:
    "好极了 真的很棒... .我们在游戏中非常兴奋, 这使得性爱更加激烈，到处都充满了快感! 我们已经开始期待再次玩了💦🔥我们也推荐付费版，如果你能承受性饥渴的话 🤤’",

  tituloBloco6Novo:
    "像全球数百对情侣一样，为你们的爱情生活增添色彩。发现 1,500 多个新的情侣挑战。",
  texto6Select: "选择版本：",
  texto6Premium: "高级版",
  texto6Assinatura: "订阅",
  texto6Semanal: "每周",
  texto6Mensal: "月费",
  texto6Anual: "年费",
  texto6Vitalicia: "终身",
  bePremium: "成为高级用户",
  buyNew: "购买",
  attention: "注意！",
  changeGender: "您已更改性取向",

  tituloAvaliacao: "喜欢这个游戏吗？",
  textoAvaliacao: "为我们评分，帮助我们不断进步！",
  agoraNão: "现在不要",
  enviarAvaliacao: "发送",

  nomeJogo1: "辣挑战",
  nomeJogo2: "真心话大冒险 ?!",
  nomeJogo3: "调皮程度",
  nomeJogo4: "调情轮盘",
  nomeJogo5: "热辣提示",
  naughtyQuiz: "性感测试",

  playAlone: "自己玩",
  estaSozinho: "你一个人吗？",
  selectPlayer: "选择玩家",

  skip: "跳过",
  responder: "发送",
  respondaAqui: "请在此回复",
  config4: "选择头像进行个性化",

  tituloSelect1: "一个人玩吗？",
  tituloSelect2: "回答大胆的问题！",

  subTituloSelect1: "我们来帮你",
  subTituloSelect2: "发现你有多淘气！",
  txtJogador1: "选择你的玩家，探索专为你设计的引导式独自享乐！",
  txtJogador2: "所选玩家将回答问题",
  tituloCena: "你想使用哪些物品？",
  subTituloCena: '你还没有？点击 "购买"，从合作商店购买。',
  play: "玩游戏",

  titleUserWarning: "选择用户",
  txtUserWarning: "选择一个用户回答问题",

  shareNivelDeSafadeza:
    "嘿，看看我的调皮程度😈 体验强烈的快感时刻。您也应该试试💋 现在就下载app，准备好与您的伴侣一起享受辣辣的挑战🔥！：➡️ https://desafiospicantesapp.page.link/sharelevelhot",

  shareDica:
    "立即改变你的爱情生活！下载该app，发现亲密关系的秘密：➡️ https://desafiospicantesapp.page.link/tipoftheday",
  resultadoQuiz1: "你是一个谦逊的人，对淘气不太感兴趣，更喜欢一些浪漫的东西！",
  resultadoQuiz2: "你太浪漫，无法沉迷于淘气，更喜欢烛光晚餐的氛围。",
  resultadoQuiz3: "你是一个非常注重隐私的人，认为在亲密生活中要保持谨慎和私密 ",
  resultadoQuiz4:
    "这并不意味着你有时不淘气，但你更愿意将所有的激情留给某个非常特别的人。",
  resultadoQuiz5: "你的热情在背后，但这并不改变事实，有热情存在！",
  resultadoQuiz6: "你喜欢探索新的体验，但总是在尊重和同意的前提下进行 ",
  resultadoQuiz7:
    "你喜欢热辣的约会，充满亲吻和大量的调情。不过，你也有喜欢牵着心爱对象的手看电影或吃烛光晚餐的一面。",
  resultadoQuiz8: "你愿意尝试令人兴奋的新事物，但总是很负责任。",
  resultadoQuiz9:
    "你是一个大胆的人，喜欢时不时地为自己的亲密生活增添一点刺激。",
  resultadoQuiz10: "你喜欢享受生活中的一切乐趣，在性方面更是无拘无束。",
  resultadoQuiz11:
    '对于你来说，没有不适合的时机！爱情电影？只有是 "50 Shades of Grey”',
  resultadoQuiz12: "对于你来说，亲密关系是一次不断的冒险，你毫不畏惧冒险。",
  mes: "月",
  desafiosRestantesDois: "你还有2个高级挑战！",
  nenhumDesafioRestante: "没有更多的高级挑战了！",
  tornePremiumAviso1: "立即成为高级用户，尽享1000个专属挑战！",
  tornePremiumAviso2: "畅享无限挑战、独家内容和不间断的乐趣！",
  conteudoPremium: "你选择了高级内容！",
  aproveite4desafios: "享受 4 项高级挑战，体验独一无二的乐趣。",

  calculando: "计算结果...",
  nivelRomantismo: "你的浪漫程度是...",
  finalizar: "完成",
  erroQuizTitulo: "输入你的答案",
  erroQuizFrase: "为了继续，请输入你的答案！",
  new: "新应用",

  //resposta quiz safadeza
  resQuiz1: "温柔",
  resQuiz2: "浪漫",
  resQuiz3: "诱人的",
  resQuiz4: "超级淘气",

  tempSemanal: "每周收费",
  tempMensal: "每月收费",
  tempAnual: "每年收费",
  tempSempre: "一次性付款",
  canceleAny: "随时取消",

  //Tela do safadrometro
  Low: "低",
  Medium: "中",
  High: "高",

  lifeTime: "终身访问",
  notNow: "不现在，谢谢",
  match: "与 A.I. 配对",

  //Modal date
  dateTitle: "想要试用我们的新应用吗？",

  dateBody: `想要和调皮😈的机器人聊天并练习调情吗？你会很开心的！🔥`,
  goToDate: "立即尝试Date.AI！",
  goodForU: "这对你有好处吗？",
  rateOurPerformance: "评价我们到目前为止的表现",
  veryGood: "很好",
  veryBad: "很糟糕",
  feedbackChallenge:
    "是什么促使你与其他情侣分享Hot Challenges应用程序的，为什么？",
  type: "在此输入您的回答...",
  survey: "满意度调查。",
  shareIfConfortable: "如果你愿意，可以随意与朋友分享 :)",

  howToPlay: "怎麼玩",
  howToPlayHotChallenge:
    "准备好增加刺激吧！抽一张挑战卡，用火辣的动作给你的伴侣一个惊喜!",

  preGameTip1: "释放你的欲望，与伴侣一起创造难忘的时刻！",
  preGameTip2: "点燃你的激情，共同创造难忘的时刻！",
  preGameTip3: "探索你最狂野的欲望，创造永生难忘的回忆!",
  preGameTip4: "解放你的幻想，尽情享受纯粹的快感时刻！",
  selecionajoagador: "是时候玩了",
  dica: "提示",

  howToPlayNaughty:
    "选择你最喜欢的玩具和道具。转动轮盘，让命运决定你的下一个淘气挑战！",
  howToPlayTruthOrDare:
    "选择你的命运：分享一个真相，或者接受一个大胆的挑战。让乐趣开始吧！",

  howToKama1: "探索激情姿势——365天的激情体验！",
  howToKama2: "抽取一张随机卡片，尝试这个姿势，一起探索快感的新高度！",
  kamaExplain:
    "每天解锁一个新姿势，打造属于你的激情珍藏——365天难忘快感的旅程，就从这里开始！",
  howToDo: "如何操作",
  pergunta: "问题",

  restart: "重新开始",
  dialogText1HotChallenges: "您已完成所选类别的所有可用挑战。",
  dialogText2HotChallenges: "选择更多类别或用当前的挑战重新开始游戏！",
  noChallenges: "没有挑战！",
  objects: "物体",
  dialogText1NaughtyGames: "您已完成选定物体的所有可用挑战。",
  dialogText2NaughtyGames: "选择更多物体或使用当前挑战重新开始游戏！",

  unlockPremium: "解锁高级版",
  noCategory: "请至少选择一个类别开始。",
  thanksForFeedback: "感谢您帮助我们改善体验！",
  categoryKamasutra: "选择你的激情，开始玩乐！",
  tap: "点击揭晓你的姿势！",
  step: "分步指南",
  shareQuizButton: "分享你的淘气程度！",
  tryAgain: "再试一次",
  unlockAllFun: "解锁所有乐趣",
  limitedOffer: "限时特惠！",
  fill: "输入您的名字和您伴侣的名字。",

  kamaNotificationTitle: "🔥 您的新卡片已解锁！",
  kamaNotificationBody:
    "您的第 {variavel} 天姿势已准备好。今天尝试点新东西怎么样？💋",

  titleNewGame: "准备好角色扮演吧！",
  phraseNewGame:
    "在下一次更新中，一个全新的游戏将帮助您探索最具创意的幻想。选择角色，创造故事，与伴侣一起将乐趣提升到新的高度。🔥",
  awaitNewGame: "敬请期待，为独特时刻做好准备！",
  selectObjects: "选择两个或更多物品来定制您的游戏。尽情探索吧。",
  soon: "即将上线",
  wantToBeNotify: "我想被通知",
  ok: "好的",
  vezDe: "转弯",

  categoryLabel: "类别",
  descriptionLabel: "描述",

  loginConnect: "登录",
  loginNoAccount: "没有账户？",
  loginCreateNow: "立即创建",
  loginOrConnect: "或连接",

  email: "电子邮件",
  password: "密码",
  loginRegister: "注册",
  loginAlreadyHas: "已经有账户？",
  enterNow: "现在登录",

  logout: "登出",
  customerPortal: "客户门户网站",
  installApp: "安装应用程序",
  loginVideo:
    "https://desafios-picantes-bucket.dev12br.com/videos-login/chines.mp4",
};
